exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2K6rYqcJjh5Lfguf2DQ9UO{border:1px solid transparent;margin-left:-15px;margin-right:-15px;overflow:auto;zoom:1}._3EqvkvZ0AgixqdwhgNRl7n{float:left;padding:15px}._2VZJuRg7-O8BxapsCsVbW7{float:left;width:100%;margin-bottom:30px}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/Masonry/style.css"],"names":[],"mappings":"AAAA,yBACI,6BAA8B,AAC9B,kBAAmB,AACnB,mBAAoB,AAEpB,cAAe,AACf,MAAQ,CACX,AAED,yBACI,WAAY,AACZ,YAAc,CACjB,AAED,yBACI,WAAY,AACZ,WAAY,AACZ,kBAAoB,CACvB","file":"style.css","sourcesContent":[".box {\n    border: 1px solid transparent;\n    margin-left: -15px;\n    margin-right: -15px;\n    \n    overflow: auto;\n    zoom: 1;\n}\n\n.col {\n    float: left;\n    padding: 15px;\n}\n\n.item {\n    float: left;\n    width: 100%;\n    margin-bottom: 30px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"box": "_2K6rYqcJjh5Lfguf2DQ9UO",
	"col": "_3EqvkvZ0AgixqdwhgNRl7n",
	"item": "_2VZJuRg7-O8BxapsCsVbW7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/Masonry/style.css
// module id = 877
// module chunks = 0 1 2 3 4 6